import { useMemo } from 'react';

import DashboardTitleWithTooltip from 'components/insights/careTransitions/shared/DashboardTitleWithTooltip';
import InsightsTabsFilterBar from 'components/insights/filterBar/InsightsTabsFilterBar';
import { FilterSection } from 'components/shared/filters/FilterSlideout';
import { TabType } from 'components/Tabs';
import { SENDING_GROUP } from 'constants/filterKeysConstants';
import { useReferralsInsightsActions, useReferralsInsightsStore } from 'stores/referralsInsightsStore';

import { filtersForGroupType, getFilterSections } from '../../filters';
import { useReferralsInsightsContext } from '../ReferralsContainer';

type ReferralsFilterBarProps = {
  tabs: TabType[];
  selectedTab?: TabType;
  onTabClick: (tab: TabType) => void;
};

export default function ReferralsFilterBar({ tabs, selectedTab, onTabClick }: ReferralsFilterBarProps) {
  const { predecessorGroupType } = useReferralsInsightsContext();
  const selectedReceivingGroupType = useReferralsInsightsStore((state) => state.selectedReceivingGroupType);
  const filters = useReferralsInsightsStore((state) => state.filters);
  const { setSelectedFilters } = useReferralsInsightsActions();

  const filterSections = useMemo(
    () => getFilterSections(predecessorGroupType, selectedReceivingGroupType, SENDING_GROUP),
    [predecessorGroupType, selectedReceivingGroupType]
  );

  const activeFilters = useMemo(
    () =>
      selectedReceivingGroupType ? filtersForGroupType(filters, selectedReceivingGroupType, SENDING_GROUP) : filters,
    [filters, selectedReceivingGroupType]
  );

  return (
    <InsightsTabsFilterBar
      title={
        <DashboardTitleWithTooltip
          title='Referral Coordination'
          tooltipText='SNF referrals only. LTC referrals are not included.'
        />
      }
      gtmPrefix='insightsReferrals'
      tabs={tabs}
      selectedTab={selectedTab}
      onTabClick={onTabClick}
      filters={activeFilters}
      filterSections={filterSections as FilterSection[]}
      setSelectedFilters={setSelectedFilters}
    />
  );
}
